import BaseModal, { BaseModalProps } from './BaseModal'

export { type BaseModalProps }

export default BaseModal
